
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //baseURL: 'http://localhost:8080/indiangrocery/indian-grocery/API/index.php/',
  //mediaURL: 'http://localhost:8080/indiangrocery/indian-grocery/API/uploads/',
  baseURL: 'https://apiindiangrocery.24x7it.in/index.php/',
  mediaURL: 'https://apiindiangrocery.24x7it.in/uploads/',
  onesignal: {
    appId: '67ce0dc4-d91b-47b1-9461-e5435a59ef4d',
    googleProjectNumber: '62057288644',
    restKey: 'NzE1YmEyZjItNThjOS00ZDk2LThiNDktNmJmYzk1ZjQ2ZGQ3'
  },
  general: {
    symbol: '$',
    code: 'USD'
  },
  authToken: '24x7itpl'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
